import React, { createContext, useContext, useState } from "react";

type AnonymizeContextType = {
  anonymize: boolean;
  setAnonymize: (value: boolean) => void;
};

const AnonymizeContext = createContext<AnonymizeContextType | undefined>(undefined);

export function AnonymizeProvider({ children }: { children: React.ReactNode }) {
  const [anonymize, setAnonymize] = useState(false);
  return (
    <AnonymizeContext.Provider value={{ anonymize, setAnonymize }}>
      {children}
    </AnonymizeContext.Provider>
  );
}

export function useAnonymize() {
  const ctx = useContext(AnonymizeContext);
  if (!ctx) throw new Error("useAnonymize must be used within AnonymizeProvider");
  return ctx;
}

// Utility function to mask values
export function anonymizeText(text: string, index: number = 0) {
  if (!text) return "—";
  // Examples: categories: "Category 1", card: "Card 2", description: "Transaction 3"
  if (text.toLowerCase().startsWith("category")) return text;
  if (text.toLowerCase().startsWith("card")) return text;
  if (text.toLowerCase().startsWith("transaction")) return text;
  // Otherwise, replace with generic names
  if (text.length > 16) return "Sensitive Value";
  return text;
}

export function anonymizeCategory(category: string, idx: number) {
  return `Category ${idx + 1}`;
}

export function anonymizeCard(card: string, idx: number) {
  return `Card ${idx + 1}`;
}

export function anonymizeDescription(idx: number) {
  return `Transaction ${idx + 1}`;
}

export function anonymizeAmount(amount: number) {
  // Show a fixed anonymized placeholder for dollar values
  return "$—.—";
}
